import React from 'react';
import LogoImg from '../../../assets/logo.png';

function Logo() {
  return (
    <div className="logo">
      <img src={LogoImg} alt="gifthub_logo" />
    </div>
  );
}

export default Logo;
